declare namespace $ {

	type $shm_hitalama_map_widget_float_table_grid_list__sub_shm_hitalama_map_widget_float_table_grid_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_grid['rows'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid_list['sub'] >
	>
	type $shm_hitalama_map_widget_float_table_grid_list__scroll_top_shm_hitalama_map_widget_float_table_grid_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_grid['scroll_top'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid_list['scroll_top'] >
	>
	type $shm_hitalama_map_widget_float_table_grid_list__viewport_height_shm_hitalama_map_widget_float_table_grid_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_grid['viewport_height'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid_list['viewport_height'] >
	>
	type $shm_hitalama_map_widget_float_table_grid_list__header_height_shm_hitalama_map_widget_float_table_grid_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_grid['header_height'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid_list['header_height'] >
	>
	type $shm_hitalama_map_widget_float_table_grid_list__render_visible_only_shm_hitalama_map_widget_float_table_grid_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_grid['render_visible_only'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_grid_list['render_visible_only'] >
	>
	export class $shm_hitalama_map_widget_float_table_grid extends $mol_grid {
		scroll_top( next?: number ): number
		viewport_height( ): number
		header_height( ): number
		render_visible_only( ): boolean
		Table( ): $shm_hitalama_map_widget_float_table_grid_list
	}
	
	export class $shm_hitalama_map_widget_float_table_grid_list extends $mol_grid_table {
		render_visible_only( ): boolean
		scroll_top( next?: number ): number
		viewport_height( ): number
		row_height( ): number
		header_height( ): number
		overscan( ): number
	}
	
}

//# sourceMappingURL=grid.view.tree.d.ts.map